import {makeAutoObservable, reaction} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IMenuStore} from "data/stores/menu/menu.store";
import type {IUser, IUserStore} from "data/stores/user/user.store";
import {GIGYA_KEY} from "data/constants";

export interface IHeaderController extends ViewController {
	readonly i18n: ILocalizationStore;

	get isAuthorized(): boolean;
	get user(): IUser | undefined;
	get isOpenMenu(): boolean;

	toggleMenu: () => void;
	closeMenu: () => void;
	SSOLogin: () => void;
}

@injectable()
export class HeaderController implements IHeaderController {
	get isAuthorized() {
		return this._userStore.isAuthorized;
	}

	get user() {
		return this._userStore.user;
	}

	get isOpenMenu(): boolean {
		return this._menuStore.isOpenMenu;
	}

	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.MenuStore) private _menuStore: IMenuStore
	) {
		makeAutoObservable(this);

		reaction(
			() => this.isOpenMenu,
			(isOpenMenu) => {
				const rootElement = document.querySelector("body");

				if (rootElement) {
					rootElement.style.overflow = isOpenMenu ? "hidden" : "initial";
				}
			}
		);
	}

	toggleMenu = () => {
		this._menuStore.toggleMenu();
	};

	closeMenu = () => {
		this._menuStore.closeMenu();
	};

	SSOLogin = () => {
		window.gigya?.sso.login({
			authFlow: "redirect",
			apiKey: GIGYA_KEY,
		});
	};
}
